export default __webpack_public_path__ + "static/media/pot.8a6196d5.png";